import { doc, updateDoc } from "@firebase/firestore";
import { db } from "../../../firebase";

const DeleteExam = async (ID) => {
  try {
    const ExamDocument = doc(db, "Exams", ID);

    await updateDoc(ExamDocument, {
      IsDeleted: true,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteExam;
